module.exports = __webpack_public_path__ + "order/img/404.dced3671.jpg";